import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
    mode: 'hash',
    base: '/',
    routes: [
        {
            path: '/',
            redirect: '/chat-demo'
        },
        {
            path: '/chat-demo',
            name: 'ChatDemo',
            component: r => require.ensure([], () => r(require('@/pages/chat-demo/main.vue')), 'ChatDemo'),
            meta: { requiresAuth: false }
        },
        {
            path: '/admin-login',
            name: 'AdminLogin',
            component: r => require.ensure([], () => r(require('@/pages/admin-login/index.vue')), 'AdminLogin'),
            meta: { requiresAuth: false }
        },
        {
            path: '/admin',
            name: 'Admin',
            component: r => require.ensure([], () => r(require('@/pages/admin/index.vue')), 'Admin'),
            meta: { requiresAuth: true, requiresAdmin: true }
        }
    ]
});

router.beforeEach((to, from, next) => {
    const adminToken = localStorage.getItem('admin_auth_token');
    const adminUserInfo = JSON.parse(localStorage.getItem('admin_user_info') || '{}');
    const isAdminLoggedIn = adminToken && adminUserInfo.isAdmin;

    document.title = process.env.VUE_APP_PAGE_TITLE || 'SG 智能客服';

    // 仅拦截组件内重复导航，避免阻断首次加载（from.name 为空表示初始导航）
    if (to.path === from.path && from.name) {
        next(false);
        return;
    }

    if (to.path === '/admin-login') {
        if (isAdminLoggedIn) {
            next('/admin');
        } else {
            next();
        }
        return;
    }

    if (to.path === '/admin') {
        if (isAdminLoggedIn) {
            next();
        } else {
            next('/admin-login');
        }
        return;
    }

    next();
});

export default router;
